import React from "react"
import classNames from "classnames"

interface ICustomBadgeProps {
  /**
   * Badge label text.
   */
  label: string
  /**
   * The background color of the badge.
   */
  backgroundColor?: string
  /**
   * className to add to the badge container element
   */
  className?: string

  /**
   * Whether to display the badge or not
   */
  enabled?: boolean
}

const CustomBadge = ({
  enabled = true,
  label,
  backgroundColor,
  className = "",
}: ICustomBadgeProps) => {
  if (!enabled) {
    return null
  } else {
    return (
      <div className={classNames("w-fit", className)}>
        <div
          className="rounded-[4px] px-[9px] py-[2px] text-center font-sans font-black uppercase text-white"
          style={{ backgroundColor }}
        >
          {label}
        </div>
      </div>
    )
  }
}

export default CustomBadge
